import { useEffect, useRef } from "react";
import "./HelpOverlay.css";

const THINGS = [
  { icon: "✈️", text: "Tap any plane to see everything about it" },
  { icon: "🔎", text: "Search a flight by its callsign" },
  { icon: "🗺️", text: "Switch between Map and List view" },
  { icon: "🔔", text: "Watch a flight to get a notification" },
  { icon: "🎨", text: "Pick a colour theme you like" },
  { icon: "📲", text: "Install this app to your home screen" },
];

export default function HelpOverlay({ open, onClose }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    function onKeyDown(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose();
      }
    }

    document.addEventListener("keydown", onKeyDown);
    // Move focus to the dialog when it opens.
    dialogRef.current?.focus();

    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  function onBackdropClick(e) {
    // Close only when the backdrop itself is clicked, not the dialog body.
    if (e.target === e.currentTarget) onClose();
  }

  return (
    <div className="help-backdrop" onClick={onBackdropClick}>
      <div
        className="help-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="help-title"
        tabIndex={-1}
        ref={dialogRef}
      >
        <h2 id="help-title" className="help-title">
          Welcome to Plane Spotter
        </h2>
        <p className="help-intro">
          A calm way to watch the planes flying overhead. Here is everything
          you can do.
        </p>

        <ul className="help-list">
          {THINGS.map((thing) => (
            <li key={thing.text} className="help-item">
              <span className="help-item-icon" aria-hidden="true">
                {thing.icon}
              </span>
              <span className="help-item-text">{thing.text}</span>
            </li>
          ))}
        </ul>

        <button className="help-close" onClick={onClose}>
          Got it — start spotting
        </button>
      </div>
    </div>
  );
}
